import { createSelector } from 'reselect';

const selectAbTester = (state) => state.abTester;

const selectAbTesterQueriedSuccesfully = createSelector(
  selectAbTester,
  ({ error, wasQueried }) => wasQueried && error === undefined,
);

export { selectAbTester, selectAbTesterQueriedSuccesfully };
